var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4399 9.85993H16.5601C17.3551 9.85993 18 9.25081 18 8.5C18 7.74919 17.3551 7.14007 16.5601 7.14007H10.4399V1.35993C10.4399 0.609117 9.79498 0 9 0C8.20502 0 7.56007 0.609117 7.56007 1.35993V7.14007H1.43993C0.644948 7.14007 0 7.74919 0 8.5C0 9.25081 0.644948 9.85993 1.43993 9.85993H7.56007V15.6401C7.56007 16.3909 8.20502 17 9 17C9.79498 17 10.4399 16.3909 10.4399 15.6401V9.85993Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.5d26edaa.svg";
export { ForwardRef as ReactComponent };